import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { Input } from 'antd';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
import FormattedInput from 'components/FormattedInput/Loadable';

import ButtonWithToolTip from 'components/ButtonWithToolTip';
import CarryForwardTooltip from 'components/CarryForwardTooltip';
import messages from 'containers/QuestionnairePage/MatrixAndConceptsTable/messages';

const TextAreaInput = Input.TextArea;

function MatrixAndConceptsViewOnlyTableHeader({
  item,
  tableType,
  headerType = 'row',
  inputType = 'input',
  maxLength,
  intl,
}) {
  const isMatrixTableType = tableType === 'matrix';
  const hasLabel = !(tableType !== 'matrix' && headerType === 'column');
  const isRow = headerType === 'row';
  const maxTextAreaRows = isRow ? 9 : 7;
  const { label } = item;
  const body = item.body || item.name;

  return (
    <div className="padding-left-xxs padding-vertical-sm">
      <div className="display-flex flex-items-center w-full break-normal">
        {isMatrixTableType && (
          <div className="margin-right-tiny" style={{ width: 13 }}>
            {item.isCarriedForward && (
              <CarryForwardTooltip
                questionRefId={item.questionRefId}
                className="color-grey-10 position-relative"
                spanStyle={{
                  width: 13,
                  height: 13,
                  fontSize: 13,
                  top: -1,
                }}
              />
            )}
          </div>
        )}

        <div className="flex-1 display-flex flex-items-center background-grey-4 text-size-secondary border-radius-level-1 padding-xs">
          {hasLabel && (
            <span
              className={classNames(
                'text-size-secondary margin-right-xxs color-grey-8',
                'flex-self-start',
              )}
            >
              {label}
            </span>
          )}

          {inputType === 'input' && (
            <input
              type="text"
              maxLength={maxLength}
              value={body}
              placeholder={intl.formatMessage(
                messages[tableType][headerType].placeholder,
                {
                  index: item.index + 1,
                },
              )}
              disabled
              className={classNames(
                'flex-1 w-full outline-none color-grey-10 color-grey-8-placeholder',
                'text-size-secondary padding-none cursor-disabled',
              )}
            />
          )}

          {inputType === 'textArea' && (
            <TextAreaInput
              className={classNames(
                'w-full',
                'padding-none',
                'border-none',
                'resize-none',
                'color-grey-10',
                'color-grey-8-placeholder',
                'background-grey-4',
                'text-size-secondary',
                'cursor-disabled',
              )}
              style={{ lineHeight: '15px' }}
              autoSize={
                body === ''
                  ? { minRows: 1, maxRows: 1 }
                  : { minRows: 1, maxRows: maxTextAreaRows }
              }
              disabled
              placeholder={intl.formatMessage(
                messages[tableType][headerType].placeholder,
                {
                  index: item.index + 1,
                },
              )}
              value={body}
            />
          )}
          {inputType === 'formattedInput' && (
            <FormattedInput
              value={body}
              defaultHtml={body}
              readOnly
              className="display-inline-block no-height"
              inputClassName="padding-vertical-none-important"
              onChange={noop}
            />
          )}
        </div>
        <ButtonWithToolTip
          buttonClasses="cursor-default"
          disabled
          iconType="close"
        />
      </div>
    </div>
  );
}

MatrixAndConceptsViewOnlyTableHeader.propTypes = {
  tableType: PropTypes.string,
  headerType: PropTypes.string,
  inputType: PropTypes.string,
  item: PropTypes.object,
  maxLength: PropTypes.number,
  intl: PropTypes.object,
};

export default injectIntl(MatrixAndConceptsViewOnlyTableHeader);
